import React from 'react';
import { HotLead } from '../../types/hotLead';
interface ReviewBadgeProps {
  review: HotLead['review'];
  /** Show the logged reason subcode underneath the status. */
  showReason?: boolean;
}
const styles: Record<HotLead['review']['status'], string> = {
  pending: 'border-slate-200 bg-slate-100 text-slate-700',
  agreed: 'border-[#acf3e4] bg-[#ebfdf7] text-[#056764]',
  overridden: 'border-[#feddc7] bg-[#fef1ed] text-[#8f4700]',
  demoted: 'border-slate-300 bg-slate-100 text-slate-600',
  dnq: 'border-[#feb8b8] bg-[#fef1f1] text-[#ba0517]'
};
const labels: Record<HotLead['review']['status'], string> = {
  pending: 'Pending',
  agreed: 'Agreed',
  overridden: 'Overridden',
  demoted: 'Demoted',
  dnq: 'DNQ'
};
export function ReviewBadge({
  review,
  showReason = false
}: ReviewBadgeProps) {
  return <span className={`inline-block rounded-full border px-2.5 py-1 text-[11px] font-semibold ${styles[review.status]}`} data-id="element-182" data-mp="18vgu6d0io4t5">
      {labels[review.status]}
      {review.reasonCode ? ` · ${review.reasonCode}` : ''}
      {showReason && review.reasonSubcode && <span className="block font-normal opacity-80" data-id="element-183" data-mp="209zolgsm3uzg">{review.reasonSubcode}</span>}
    </span>;
}